/**
 * Provider map for the auth UI (login/signup forms).
 *
 * Separated from auth.ts so client components ("use client") can import it
 * without pulling in server-only auth dependencies.
 */

type Provider = { id: string; name: string; icon: string };
type AppName = "open" | "exams";

const isUS = process.env.NEXT_PUBLIC_REGION === "us";

const google: Provider = {
  id: "google",
  name: "Google",
  icon: "/google_logo.svg",
};
const apple: Provider = {
  id: "apple",
  name: "Apple",
  icon: "/apple_logo.svg",
};
const microsoft: Provider = {
  id: "microsoft",
  name: "Microsoft",
  icon: "/microsoft_logo.svg",
};

export function getProviderMap(app: AppName): Provider[] {
  switch (app) {
    case "exams":
      return isUS ? [google, microsoft] : [google, apple, microsoft];
    case "open":
      return isUS ? [google, microsoft] : [google, apple, microsoft];
  }
}
